import { DEFAULT_THEME, THEMES, type Theme, type ThemeId } from "./themes/registry";

const themeIds = new Set<string>(THEMES.map(theme => theme.id));

export function isThemeId(value: unknown): value is ThemeId {
  return typeof value === "string" && themeIds.has(value);
}

export function themeId(value: unknown): ThemeId {
  return isThemeId(value) ? value : DEFAULT_THEME;
}

function themeDefinition(value: unknown): Theme {
  const id = themeId(value);
  return THEMES.find(theme => theme.id === id) ?? THEMES[0];
}

export function applyTheme(value: unknown): ThemeId {
  const theme = themeDefinition(value);
  const root = document.documentElement;
  root.dataset.theme = theme.id;
  root.style.setProperty("--theme-status-bar-color", theme.statusBarColor);
  const colorMeta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (colorMeta) colorMeta.content = theme.statusBarColor;
  const styleMeta = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-status-bar-style"]');
  if (styleMeta) styleMeta.content = theme.statusBarStyle;
  return theme.id;
}
